var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "email-preview" }, [
    _c("h2", [_vm._v(_vm._s(_vm.$t("support.emailPreviewDetails.header")))]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", { staticClass: "table table-hover" }, [
      _c("thead", [
        _c("tr", [
          _c("th", [_vm._v("Name")]),
          _vm._v(" "),
          _c("th", [_vm._v("Type")]),
          _vm._v(" "),
          _c("th", [_vm._v("Beschriebung")]),
          _vm._v(" "),
          _c("th", [_vm._v("Link")])
        ])
      ]),
      _vm._v(" "),
      _c("tbody", [
        _c("tr", [
          _c("td", [_vm._v("25-Tage-Mail")]),
          _vm._v(" "),
          _c("td", [_vm._v("Testphase")]),
          _vm._v(" "),
          _c("td", [_vm._v("E-Mail nach 25 Tagen Testphase")]),
          _vm._v(" "),
          _c("td", [
            _c("a", { attrs: { href: "/emails/day25", target: "_blank" } }, [
              _vm._v("E-Mail Vorschau")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("30-Tage-Mail")]),
          _vm._v(" "),
          _c("td", [_vm._v("Testphase")]),
          _vm._v(" "),
          _c("td", [_vm._v("E-Mail nach 30 Tagen Testphase")]),
          _vm._v(" "),
          _c("td", [
            _c("a", { attrs: { href: "/emails/day30", target: "_blank" } }, [
              _vm._v("E-Mail Vorschau")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("45-Tage-Mail")]),
          _vm._v(" "),
          _c("td", [_vm._v("Testphase")]),
          _vm._v(" "),
          _c("td", [_vm._v("E-Mail nach 45 Tagen Testphase")]),
          _vm._v(" "),
          _c("td", [
            _c("a", { attrs: { href: "/emails/day45", target: "_blank" } }, [
              _vm._v("E-Mail Vorschau")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("80-Tage-Mail")]),
          _vm._v(" "),
          _c("td", [_vm._v("Testphase")]),
          _vm._v(" "),
          _c("td", [_vm._v("E-Mail nach 80 Tagen Testphase")]),
          _vm._v(" "),
          _c("td", [
            _c("a", { attrs: { href: "/emails/day80", target: "_blank" } }, [
              _vm._v("E-Mail Vorschau")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("90-Tage-Mail")]),
          _vm._v(" "),
          _c("td", [_vm._v("Testphase")]),
          _vm._v(" "),
          _c("td", [_vm._v("E-Mail nach 90 Tagen Testphase")]),
          _vm._v(" "),
          _c("td", [
            _c("a", { attrs: { href: "/emails/day90", target: "_blank" } }, [
              _vm._v("E-Mail Vorschau")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [_vm._v("welcomeNewInstance")]),
          _vm._v(" "),
          _c("td", [_vm._v("Testphase")]),
          _vm._v(" "),
          _c("td", [_vm._v("E-Mail nach erfolgreicher CT Erstellung")]),
          _vm._v(" "),
          _c("td", [
            _c(
              "a",
              {
                attrs: { href: "/emails/welcomeNewInstance", target: "_blank" }
              },
              [_vm._v("E-Mail Vorschau")]
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-97ac26d8", { render: render, staticRenderFns: staticRenderFns })
  }
}